import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@app/App';
import { bootstrapDesignSystem } from '@app/bootstrap';
import '@atlaskit/css-reset';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '@app/styles/global.css';

bootstrapDesignSystem();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
